import {useTranslation} from "react-i18next";
import {useState} from "react";
import {DEPARTMENT_TABS} from "../Model/Model";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 30 de 04 de 2026
 */
export const DepartmentTabApp = () => {

    const {t} = useTranslation();
    const [results, setResults] = useState(null);

    const [subViewChild, setSubViewChild] = useState(DEPARTMENT_TABS.ADD_DEPARTMENT.key);
    const [isAllChecked, setIsAllChecked] = useState(false);

    return {
        t,
        results,
        setResults,

        isAllChecked,
        setIsAllChecked,
        subViewChild,
        setSubViewChild
    }
}
